<template>
  <div class="overPage">
      <div class="content">
        <img src="https://cdn.133.cn/gtgj/icon/server/2018/04/over.png" alt="">
        <div class="title">活动已结束</div>
        <div class="desc">请关注管家最新活动</div>
      </div>
  </div>
</template>
<script>
  import setNavigationBarColor from '@/mixins/setNavigationBarColor'

export default {
  created() {
    this.setNavigationBarColor('255,255,255,1')
  },
  mixins: [
    setNavigationBarColor
  ]
}
</script>
<style  lang="scss" scoped>
  .overPage{
    width: 100%;
    height: 100%;
    background-color: #ccc;
    .content{
      width: 100%;
      position: fixed;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
      img{
        width: 58%;
      }
      .title{
        color: #333;
        font-size: 18px;
        margin-top: 12px;
        font-weight: 600;
      }
      .desc{
        color: #666;
        font-size: 14px;
        margin-top: 6px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/activeOver.vue